<template>
  <Modal :hideExit="true" @cancel="closeModal" classs="modal-change-traffic" :preventBackdrop="btnStatus.loading">
    <template #header>
      <p class="typo-heading20 typo-medium text-light-high">
        {{ $t("analytic.ab.setTrafficPerc") }}
      </p>
    </template>
    <template #default>
      <template>
        <div class="col-12 p-0">
          <div class="form-group">
            <p class="typo-paragraph14 typo-regular-150 text-light-low mb-1">{{ $t("analytic.ab.trafficPerc") }}</p>
            <div class="d-flex align-items-center flex-grow-1">
              <p class="typo-button14 typo-medium text-light-high">{{ $t("analytic.ab.original") }}</p>
              <div class="input-percent ml-3">
                <input placeholder="50%" class="input-field input-field-block" type="number" :min="1" :max="99" v-model="main" @keyup.enter="updatePercent" @input="updateVariantPercent" />
              </div>
              <div class="input-range d-flex flex-grow-1 ml-4">
                <input v-focus ref="inputTitle" type="range" :min="1" :max="99" v-model="main" @input="updateVariantPercent" />
              </div>
              <div class="input-percent ml-4">
                <input placeholder="50%" class="input-field input-field-block" type="number" :min="1" :max="99" v-model="variants" @keyup.enter="updatePercent" @input="updateMainPercent" />
              </div>
              <p class="typo-button14 typo-medium text-light-high ml-3">{{ $tc("analytic.ab.variant", 1) }}</p>
            </div>
            <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">
              {{ alertText }}
            </p>
          </div>
          <div class="d-flex p-relative p-2 flex-grow-1 warn-info mt-2">
            <i class="icon icon-warning typo-icon-16 mr-1 mt-half text-primary weight-600"></i>
            <p class="typo-button14 typo-regular-150 text-light-high" v-html="$t('analytic.ab.changeTrafficDesc')"></p>
          </div>
        </div>
      </template>
    </template>
    <template #footer>
      <div class="btn-group flex-row-reverse">
        <ProcessButton class="btn-primary btn-default px-4 ml-2" :status.sync="btnStatus" @click="updatePercent" type="submit">
          <template #loading>{{ $t("generals.saving") }}</template>
          <template #success>{{ $t("generals.success") }}</template>
          <template #error>{{ $t("generals.fail") }}</template>
          <template #default>{{ $t("generals.save") }}</template>
        </ProcessButton>

        <button class="btn btn btn-outline btn-default px-3" @click="closeModal">
          {{ $t("generals.cancel") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";
import { actions } from "@/store/analytic/types.js";
import processButton from "@/mixins/processButton.js";
import errorHandle from "@/mixins/errorHandle.js";

export default {
  name: "ModalUpdatePercent",
  components: {},
  mixins: [
    processButton(),
    errorHandle(),
  ],
  props: {
    campaign: Object
  },
  data() {
    return {
      alertText: "",
      main: 50,
      variants: 50
    };
  },
  computed: {},
  created() {
    if (this.campaign && this.campaign.pages) {
      const mainPage = this.campaign.pages.find(item => item.is_main_page);
      if (mainPage) {
        this.main = Math.round(mainPage.percent * 100);
        this.variants = Math.round(100 - this.main);
      }
    }
  },
  methods: {
    ...mapActions("analytic", {
      updatePagesPercent: actions.UPDATE_PERCENTS_ANALYTIC
    }),
    closeModal() {
      this.$emit("close");
    },
    updateVariantPercent() {
      if (this.main < 1) {
        this.main = 1;
      }
      if (this.main > 99) {
        this.main = 99;
      }
      this.variants = Math.round(100 - this.main);
    },
    updateMainPercent() {
      if (this.variants < 1) {
        this.variants = 1;
      }
      if (this.variants > 99) {
        this.variants = 99;
      }
      this.main = Math.round(100 - this.variants);
    },
    updatePercent() {
      let { main, variants } = this;
      main /= 100;
      variants /= 100;
      let textSuccess = this.$t("status.success");
      const variantCount = this.campaign.pages.length - 1;
      const pages = this.campaign.pages.map(x => {
        const item = {
          id: x.g_id
        };
        if (x.is_main_page) {
          item.percent = main;
        } else {
          item.percent = variants / (variantCount || 1);
        }
        return item;
      });
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.activeLoading();
      this.updatePagesPercent({ id: this.campaign.id, pages })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.activeSuccess();
          this.$emit("change", { main, variants });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
          this.activeError();
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 1000);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-change-traffic::v-deep {
  .gp_modal {
    &-container {
      max-width: 640px;
      width: 70vw;
    }
  }
}
.warn-info {
  background: rgba($mono1, 0.1);
}
.input-percent {
  width: 64px;
  input {
    width: 100%;
    padding-right: 4px;
  }
}
.input-range {
  input[type="range"] {
    width: 100%;
    transition: opacity 0.3s;
    -webkit-appearance: none;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    height: 2px;

    &::-webkit-slider-thumb,
    &::-moz-range-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 16px;
      height: 16px;
      background: $mono3;
      cursor: pointer;
      border-radius: 50%;
    }

    &:hover {
      opacity: 1;
    }
  }
}
</style>
